export const waitForEvent = (el, eventName) => {
  return new Promise((resolve) => {
    function done(e) {
      if (e.target === el) {
        el.removeEventListener(eventName, done);
        resolve();
      }
    }

    el.addEventListener(eventName, done);
  });
};

export const animateTo = (el, keyframes, options) => {
  return new Promise((resolve, reject) => {
    const animation = el.animate(keyframes, {
      ...options,
      duration: prefersReducedMotion() ? 0 : options.duration,
    });

    animation.addEventListener('finish', resolve, { once: true });
    animation.addEventListener('cancel', () => reject(new Error('Animation was cancelled')), { once: true });
  });
};

export const stopAnimations = (el) => {
  return Promise.all(
    el.getAnimations().map((animation) => {
      return new Promise((resolve) => {
        const handleAnimationEvent = requestAnimationFrame(resolve);

        animation.addEventListener('cancel', () => handleAnimationEvent, {
          once: true,
        });
        animation.addEventListener('finish', () => handleAnimationEvent, {
          once: true,
        });
        animation.cancel();
      });
    }),
  );
};

export const shimKeyframesHeightAuto = (keyframes, calculatedHeight) => {
  return keyframes.map((keyframe) => ({
    ...keyframe,
    height: keyframe.height === 'auto' ? `${calculatedHeight}px` : keyframe.height,
  }));
};

export const prefersReducedMotion = () => {
  const query = window.matchMedia('(prefers-reduced-motion: reduce)');
  return query.matches;
};
